module.exports = __webpack_public_path__ + "img/IMG-20200606-WA0011.b53a8bcb.jpg";